// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { RootState, AppDispatch } from './store';
import { IStrings } from '../services/localization';
import { selectStrings } from './localization.slice';

// Use throughout the app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Localization hooks
export const useStrings: () => IStrings = () => useAppSelector(selectStrings);
